import { render, staticRenderFns } from "./ProductThumb.vue?vue&type=template&id=ba02ca82&"
import script from "./ProductThumb.vue?vue&type=script&lang=js&"
export * from "./ProductThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports